import react from 'react';
import react_dom from 'react-dom';
import * as react_router from 'react-router';
import * as react_use from 'react-use';
import * as react_router_dom from 'react-router-dom';
import * as rxjs from 'rxjs';
import events from 'events';
import ali_oss from 'ali-oss';
import video_js from 'video.js';
import moment from 'moment';
import react_color from 'react-color';

import agora_rtc_sdk from 'agora-rtc-sdk';
import agora_rtm_sdk from 'agora-rtm-sdk';
import {createPlugins, DeviceType, PlayerPhase, PptKind, RoomPhase, ViewMode, WhiteWebSdk} from 'white-web-sdk';
import "white-web-sdk/style/index.css";
import {videoPlugin} from '@netless/white-video-plugin';
import {audioPlugin} from '@netless/white-audio-plugin';


const white_video_plugin = {videoPlugin};
const white_audio_plugin = {audioPlugin};
const white_web_sdk = {PptKind, ViewMode, createPlugins, DeviceType, RoomPhase, WhiteWebSdk, PlayerPhase};


const XM_DEPENDENCIES2 = {
    events,
    react,
    react_dom,
    react_router,
    react_router_dom,
    react_use,
    rxjs,
    ali_oss,
    agora_rtc_sdk,
    agora_rtm_sdk,
    video_js,
    white_web_sdk,
    white_video_plugin,
    white_audio_plugin,
    moment,
    react_color
};

for (let name in XM_DEPENDENCIES2){
    if (XM_DEPENDENCIES2.hasOwnProperty(name)){
        window[`XM_DEPENDENCIES_${name}`] = XM_DEPENDENCIES2[name];
    }
}

window.XM_DEPENDENCIES2 = XM_DEPENDENCIES2;

export {
    events,
    react,
    react_dom,
    react_router,
    react_router_dom,
    react_use,
    rxjs,
    ali_oss,
    agora_rtc_sdk,
    agora_rtm_sdk,
    video_js,
    white_web_sdk,
    white_video_plugin,
    white_audio_plugin,
    moment,
    react_color
}
